(function () {
  var QUIZ = window.VQ_QUIZ;
  var overlay = document.getElementById('vq-overlay');
  if (!overlay || !QUIZ) return;
  var body = overlay.querySelector('.vq-body');
  var inlineHost = document.querySelector('[data-vq-inline-host]');
  var inlineMode = !!inlineHost, inlineNeedsFocus = false;
  if (inlineMode) {
    inlineHost.appendChild(overlay);
    overlay.classList.add('vq-inline', 'vq-open');
    overlay.setAttribute('aria-hidden', 'false');
    var modal = overlay.querySelector('.vq-modal');
    modal.removeAttribute('role'); modal.removeAttribute('aria-modal');
    modal.classList.add('vpf__shell');
    overlay.querySelector('.vq-close').hidden = true;
  }
  function focusInline() {
    if (!inlineMode || !inlineNeedsFocus) return;
    inlineNeedsFocus = false;
    var heading = body.querySelector('.vpf__workspace .vpf__question');
    if (heading) heading.focus({ preventScroll: true });
    var workspace = body.querySelector('.vpf__workspace');
    if (workspace) workspace.scrollIntoView({ block: 'start', behavior: 'auto' });
  }
  var products = null, step = -1, picked = [], submitted = false;

  /* index of the question whose answer we relax when nothing matches exactly */
  var RELAX_STEP = 2;      /* User Requirement */
  var MAX_RESULTS = 3;     /* never show more than this many products */

  /* control-logic features. MCB and float switches are build options, not a
     different way of controlling the pump, so they do not count as a mismatch. */
  var CONTROL = ['cyclic timer', 'auto switch', 'water level controller',
    'clock timer', 'water level indicator', 'auto off / stop timer'];

  /* ---------- tracking ---------- */
  function slug(s) {
    return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function keyOf(qi, ai) {
    var ans = QUIZ.questions[qi].answers, base = slug(ans[ai].tags[0] || ans[ai].title);
    var dup = ans.filter(function (x) { return slug(x.tags[0] || x.title) === base; }).length > 1;
    return dup ? base + '-' + (ai + 1) : base;
  }
  function pathStr() {
    return picked.map(function (a, i) {
      if (!a) return '';
      return keyOf(i, QUIZ.questions[i].answers.indexOf(a));
    }).filter(Boolean).join('|');
  }
  function track(name, params) {
    var p = params || {};
    p.quiz = 'vukar-product-finder';
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: name }, p)); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, p); } catch (e) {}
    try { if (typeof window.fbq === 'function') window.fbq('trackCustom', name, p); } catch (e) {}
  }

  function money(v) {
    return 'Rs. ' + Number(v).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function load() {
    if (products) return Promise.resolve(products);
    return fetch('/collections/all/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        products = (j.products || []).map(function (p) {
          var vs = (p.variants || []).slice().sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
          var v0 = vs[0];
          return {
            handle: p.handle,
            title: p.title,
            image: (p.images && p.images[0] && p.images[0].src) || '',
            price: v0 ? parseFloat(v0.price) : 0,
            compare: v0 && v0.compare_at_price ? parseFloat(v0.compare_at_price) : 0,
            tags: (p.tags || []).map(function (t) { return String(t).trim().toLowerCase(); })
          };
        });
        return products;
      });
  }

  /* a null/undefined entry in picks means "ignore this question" */
  function matchList(picks) {
    return (products || []).filter(function (p) {
      return picks.every(function (a) {
        if (!a) return true;
        if (a.notHandles.indexOf(p.handle) !== -1) return false;
        var hasAll = a.tags.every(function (t) { return p.tags.indexOf(t.toLowerCase()) !== -1; });
        var hasNone = a.notTags.every(function (t) { return p.tags.indexOf(t.toLowerCase()) === -1; });
        return hasAll && hasNone;
      });
    });
  }
  function matches() { return matchList(picked); }

  /* how many control features the product has that the customer did NOT ask for */
  function extras(p, picks) {
    var asked = {};
    picks.forEach(function (a) {
      if (a) a.tags.forEach(function (t) { asked[String(t).toLowerCase()] = 1; });
    });
    var n = 0;
    CONTROL.forEach(function (t) {
      if (p.tags.indexOf(t) !== -1 && !asked[t]) n++;
    });
    return n;
  }

  /* closest fit first, then cheapest, then capped */
  function rank(list, picks) {
    return list.slice().sort(function (a, b) {
      return extras(a, picks) - extras(b, picks) || a.price - b.price;
    }).slice(0, MAX_RESULTS);
  }

  /* nothing matched all four answers: keep phase, motor type and panel/device,
     drop the requirement, and offer the closest few instead */
  function closest() {
    var relaxed = picked.slice();
    relaxed[RELAX_STEP] = null;
    return rank(matchList(relaxed), relaxed);
  }

  function steps(active) {
    var h = '<div class="vq-steps">';
    for (var i = 0; i < QUIZ.questions.length; i++) {
      if (i) h += '<div class="vq-bar"></div>';
      h += '<div class="vq-step' + (i <= active ? ' vq-done' : '') + '">' + (i + 1) + '</div>';
    }
    return h + '</div>';
  }

  const icons = {
    panel: ['M7 3h18v26H7z', 'M11 7h10v7H11z', 'M12 21h.01', 'M20 21h.01'],
    device: ['M9 6h14v20H9z', 'M13 10h6v5h-6z', 'M13 21h6', 'M12 2v4M20 2v4M12 26v4M20 26v4'],
    meter: ['M4 7h24v18H4z', 'M8 11h16v9H8z', 'M11 14h3v3h-3M18 14h3v3h-3'],
    single: ['M16 4v24', 'M11 9l5-5 5 5', 'M11 23l5 5 5-5'],
    three: ['M7 5v22M16 5v22M25 5v22', 'M4 9l3-4 3 4M13 9l3-4 3 4M22 9l3-4 3 4'],
    borewell: ['M12 9h8v20h-8z', 'M14 2h4v7M16 2h11v6', 'M2 29h28M14 14h4M14 19h4M14 24h4'],
    openwell: ['M5 6v23h22V6', 'M6 19c4-4 6 4 10 0s6 4 10 0', 'M13 8h6v17h-6zM16 8V2'],
    monoblock: ['M12 12h14v13H12z', 'M6 15h6v9H6zM3 11h4v13M26 15h3v6h-3', 'M10 28h18M16 16v5M21 16v5'],
    manual: ['M11 17V7a2 2 0 0 1 4 0v8-3a2 2 0 0 1 4 0v3-1a2 2 0 0 1 4 0v2a2 2 0 0 1 4 0v6c0 5-4 7-8 7-4 0-6-2-8-5l-5-7a2 2 0 0 1 3-3l2 3'],
    auto: ['M25 11a11 11 0 1 0 1 9', 'M25 3v8h-8', 'M16 10v7l4 2'],
    level: ['M5 6v22h22V6', 'M6 16c4-4 6 4 10 0s6 4 10 0', 'M11 7l4 4 7-7'],
    cyclic: ['M26 11a11 11 0 0 0-19-3L4 11', 'M4 4v7h7', 'M6 21a11 11 0 0 0 19 3l3-3', 'M28 28v-7h-7'],
    clock: ['M16 29a13 13 0 1 0 0-26 13 13 0 0 0 0 26', 'M16 8v9l6 3'],
    daily_runtime: ['M6 6h20v23H6z', 'M6 12h20M11 2v7M21 2v7', 'M12 19l3 3 6-6'],
    auto_off: ['M16 3v12', 'M9 7a12 12 0 1 0 14 0'],
    unknown: ['M16 29a13 13 0 1 0 0-26 13 13 0 0 0 0 26', 'M12 11a4 4 0 0 1 8 0c0 3-4 3-4 6M16 23h.01']
  };
  const icon = (key) => {
    const ns = 'http://www.w3.org/2000/svg';
    const svg = document.createElementNS(ns, 'svg');
    const add = (tag, attrs, value) => {
      const element = document.createElementNS(ns, tag);
      Object.entries(attrs).forEach(([name, item]) => element.setAttribute(name, String(item)));
      if (value !== undefined) element.textContent = value;
      svg.append(element);
      return element;
    };
    svg.setAttribute('viewBox', '0 0 96 72');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.8');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.classList.add('vpf__icon', 'vpf__icon--illustrated');
    const text = (x, y, value, size = 12, color = 'currentColor') => add('text', { x, y, fill: color, stroke: 'none', 'text-anchor': 'middle', 'font-family': 'system-ui, sans-serif', 'font-size': size, 'font-weight': '700' }, value);
    const path = (d, color = 'currentColor') => add('path', { d, stroke: color });
    const box = (x, y, width, height, fill = '#f1f2eb') => add('rect', { x, y, width, height, rx: 5, fill });
    const dot = (x, y, fill) => add('circle', { cx: x, cy: y, r: 11, fill, stroke: 'none' });
    if (key === 'single' || key === 'three') {
      const terminals = key === 'single' ? [['P', 32, '#a54132'], ['N', 64, '#315f84']] : [['R', 20, '#a54132'], ['Y', 48, '#8a6700'], ['B', 76, '#315f84']];
      terminals.forEach(([label, x, color]) => { dot(x, 21, color); text(x, 25, label, 12, '#ffffff'); path(`M${x} 34v9`, color); });
      text(48, 65, key === 'single' ? '230V' : '440V', 17);
    } else if (key === 'borewell') {
      path('M10 12h76M21 12v50M75 12v50', '#9ba99c');
      box(38, 26, 20, 37, '#e4edf0'); path('M48 26V7h24v12M43 35h10M43 43h10M43 51h10');
      path('M9 48q8-5 16 0t16 0M58 48q8-5 16 0t13 0', '#46778d');
    } else if (key === 'openwell') {
      path('M12 13v49h72V13M22 24v29h52V24', '#9ba99c');
      path('M22 37q9-6 18 0t18 0t16 0', '#46778d'); box(40, 39, 17, 21, '#e4edf0');path('M48 39V8h27v9');
    } else if (key === 'monoblock') {
      path('M8 61h80M12 27v23h16M12 27H4', '#9ba99c'); box(26, 25, 21, 30, '#e4edf0');box(47, 19, 33, 36);path('M55 26v22M63 26v22M71 26v22M33 25V9h17M30 58v3M75 58v3');
    } else if (key === 'level') {
      path('M13 11v49h70V11');path('M14 36q9-6 17 0t17 0t17 0t17 0','#46778d');path('M68 9v29M61 39h14');text(38,25,'FULL',10);path('M32 48l6 6 12-12','#55765d');
    } else if (key === 'cyclic') {
      path('M18 16h57l-7-7M78 55H21l7 7M78 17v12M18 55V43');box(9,26,33,23,'#e9f0e3');box(54,26,33,23);text(25,42,'ON',12);text(71,42,'OFF',11);
    } else if (key === 'clock') {
      add('circle',{cx:48,cy:31,r:25,fill:'#f1f2eb'});path('M48 12v4M67 31h4M48 46v4M25 31h4M48 21v11l12 6');text(48,69,'CLOCK',10);
    } else if (key === 'daily_runtime') {
      box(16,11,64,51);path('M16 26h64M30 6v11M66 6v11');text(48,49,'24h',20);path('M27 56h42');
    } else if (key === 'auto_off') {
      add('circle',{cx:43,cy:35,r:24,fill:'#f1f2eb'});path('M43 11V5M35 5h16M43 21v14l9 5');box(60,41,27,23,'#f1e5de');text(74,57,'OFF',10);
    } else if (key === 'auto_restart' || key === 'auto') {
      path('M77 20a29 29 0 1 0 1 32M77 7v15H62');path('M48 16v19M34 26a19 19 0 1 0 28 0');
    } else if (key === 'manual') {
      box(16,17,64,38);box(22,23,25,26,'#e3eddf');box(49,23,25,26);text(35,40,'ON',11);text(62,40,'OFF',10);path('M35 54v11M30 61l5-7 5 7');
    } else {
      const group = add('g', { transform: 'translate(24 9) scale(1.5)' });
      (icons[key] || icons.unknown).forEach((d) => { const shape = document.createElementNS(ns, 'path');shape.setAttribute('d', d);group.append(shape); });
    }
    return svg;
  };
  var panelConfig = {}, panelLabels = {}, panelError = '', panelStarted = false;
  try {
    var shared = document.querySelector('vukar-product-finder [data-vpf-config]');
    panelConfig = shared ? JSON.parse(shared.textContent) : {};
    panelLabels = JSON.parse(panelConfig.labels_json || '{}');
  } catch (error) {}
  function panelLabel(key, fallback) { return panelLabels[key] || fallback; }
  function panelFrame(workspace) {
    var art = document.querySelector('[data-vq-panel-art]');
    return '<header class="vpf__intro"><div class="vpf__intro-copy">' +
      (panelConfig.eyebrow ? '<p class="vpf__eyebrow">' + esc(panelConfig.eyebrow) + '</p>' : '') +
      '<h2 class="vpf__title">' + esc(QUIZ.welcome.title) + '</h2>' +
      '<ul class="vq-wsub vpf__lead">' + QUIZ.welcome.bullets.map(function (text) { return '<li>' + esc(text) + '</li>'; }).join('') + '</ul></div>' +
      (art ? art.innerHTML : '') + '</header><div class="vpf__workspace">' + workspace + '</div>';
  }
  function panelTop() {
    var current = Math.min(step + 1, QUIZ.questions.length);
    var progressText = panelLabel('step', 'Step') + ' ' + current + ' ' + panelLabel('of', 'of') + ' ' + QUIZ.questions.length;
    return '<div class="vpf__top"><div class="vpf__progress"><span class="vpf__progress-text">' + esc(progressText) + '</span>' +
      '<div class="vpf__progress-track" role="progressbar" aria-label="' + esc(panelLabel('progress_label', 'Product finder progress')) + '" aria-valuemin="0" aria-valuemax="' + QUIZ.questions.length + '" aria-valuenow="' + current + '"><span class="vpf__progress-fill" style="width:' + (100 * current / QUIZ.questions.length) + '%"></span></div></div>' +
      '<button type="button" class="vpf__text-button" data-act="panel-reset">' + esc(panelLabel('restart', 'Start over')) + '</button></div>';
  }
  function panelSummary() {
    return '<div class="vpf__summary">' + picked.map(function (answer, i) {
      return answer && i < step ? '<button type="button" class="vpf__chip" data-act="panel-edit" data-step="' + i + '">' + esc(answer.title) + '</button>' : '';
    }).join('') + '</div>';
  }
  function panelIconKey(index) {
    var tags = QUIZ.questions[step].answers[index].tags.join(' ').toLowerCase();
    if (tags.indexOf('single phase') !== -1) return 'single';
    if (tags.indexOf('three phase') !== -1) return 'three';
    if (tags.indexOf('borewell') !== -1) return 'borewell';
    if (tags.indexOf('openwell') !== -1) return 'openwell';
    if (tags.indexOf('monoblock') !== -1) return 'monoblock';
    if (tags.indexOf('motor starter') !== -1) return 'panel';
    if (tags.indexOf('device') !== -1) return 'device';
    if (tags.indexOf('clock') !== -1) return 'clock';
    if (tags.indexOf('indicator') !== -1 || tags.indexOf('level') !== -1) return 'level';
    if (tags.indexOf('auto off') !== -1) return 'auto_off';
    return 'cyclic';
  }
  function renderPanel() {
    var question = QUIZ.questions[step], isLast = step === QUIZ.questions.length - 1;
    var h = panelTop() + panelSummary() + '<h3 class="vpf__question" id="vq-panel-question" tabindex="-1">' + esc(question.title) + '</h3>' +
      (question.desc ? '<p class="vpf__helper">' + esc(question.desc) + '</p>' : '') +
      '<fieldset class="vpf__options" aria-labelledby="vq-panel-question"><legend class="vpf__sr">' + esc(question.title) + '</legend>';
    question.answers.forEach(function (answer, i) {
      h += '<label class="vpf__option"><input class="vpf__option-input" type="radio" name="vq-panel-answer" value="' + i + '" data-vq-panel-answer' + (picked[step] === answer ? ' checked' : '') + '><span class="vpf__option-content">' +
        icon(panelIconKey(i)).outerHTML + '<span class="vpf__option-copy"><span class="vpf__option-title">' + esc(answer.title) + '</span>' +
        (answer.desc ? '<span class="vpf__option-detail">' + esc(answer.desc) + '</span>' : '') +
        '</span><span class="vpf__option-mark" aria-hidden="true"></span></span></label>';
    });
    h += '</fieldset>' + (panelError ? '<p class="vpf__error" role="alert">' + esc(panelError) + '</p>' : '') +
      '<div class="vpf__nav"><button type="button" class="vpf__button vpf__button--quiet" data-act="panel-back"' + (step === 0 ? ' hidden' : '') + '>' + esc(panelLabel('back', 'Back')) + '</button>' +
      '<button type="button" class="vpf__button vpf__button--primary" data-act="panel-next"' + (!picked[step] ? ' disabled' : '') + '>' + esc(panelLabel(isLast ? 'results_button' : 'next', isLast ? 'See models to compare' : 'Continue')) + '</button></div>';
    body.innerHTML = panelFrame(h);
    focusInline();
  }
  function renderPanelResults(list, isFallback) {
    var h = panelTop() + panelSummary() + '<h3 class="vpf__question" tabindex="-1">' + esc(QUIZ.resultHeading) + '</h3>';
    if (isFallback || !list.length) h += '<p class="vpf__compatibility">' + esc(QUIZ.noMatchText || 'No matching product found.') + '</p>';
    h += '<div class="vpf__products">';
    list.forEach(function (product) {
      h += '<article class="vpf__product">' + (product.image ? '<div class="vpf__product-media"><img class="vpf__product-image" src="' + esc(product.image) + '" alt="' + esc(product.title) + '" loading="lazy" width="240" height="190"></div>' : '') +
        '<div class="vpf__product-body"><h4 class="vpf__product-title">' + esc(product.title) + '</h4><p class="vpf__price">' + money(product.price) + '</p>' +
        (product.compare > product.price ? '<p class="vq-panel-was">' + money(product.compare) + '</p>' : '') +
        '<div class="vpf__product-actions"><a class="vpf__button vpf__button--primary" data-vq-panel-product="' + esc(product.handle) + '" href="/products/' + product.handle + '">' + esc(panelLabel('view', 'View product')) + '</a></div></div></article>';
    });
    h += '</div><div class="vpf__nav"><button type="button" class="vpf__button vpf__button--quiet" data-act="panel-back">' + esc(panelLabel('back', 'Back')) + '</button></div>';
    body.innerHTML = panelFrame(h);
    focusInline();
  }
  function handlePanelAction(element) {
    var action = element.getAttribute('data-act');
    if (action === 'panel-reset') { step = 0; picked = []; submitted = false; panelStarted = false; panelError = ''; inlineNeedsFocus = true; render(); track('quiz_retake', {}); }
    else if (action === 'panel-back') { step = Math.max(0, step - 1); panelError = ''; inlineNeedsFocus = true; render(); }
    else if (action === 'panel-edit') { step = Number(element.getAttribute('data-step')); panelError = ''; inlineNeedsFocus = true; render(); }
    else if (action === 'panel-next' && picked[step]) {
      if (step < QUIZ.questions.length - 1) { step++; inlineNeedsFocus = true; render(); }
      else {
        element.disabled = true;
        load().then(function () { step++; inlineNeedsFocus = true; render(); }).catch(function () {
          panelError = panelLabel('error_body', 'Please ask us for help choosing a model.'); renderPanel();
        });
      }
    }
  }

  function render() {
    if (inlineMode && step >= 0 && step < QUIZ.questions.length) { renderPanel(); return; }
    if (step === -1) {
      body.innerHTML = '<div class="vq-wrap">' +
        '<h2 class="vq-wtitle">' + esc(QUIZ.welcome.title) + '</h2>' +
        '<ul class="vq-wsub">' + QUIZ.welcome.bullets.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('') + '</ul>' +
        '<button class="vq-btn vq-start" data-act="start">' + esc(QUIZ.welcome.button) + '</button>' +
        '</div>';
      return;
    }
    if (step === QUIZ.questions.length) { renderResult(); return; }

    var q = QUIZ.questions[step], last = step === QUIZ.questions.length - 1;
    var h = '<div class="vq-wrap">' + steps(step) +
      '<h2 class="vq-q">' + esc(q.title) + '<span class="vq-req">*</span></h2>' +
      (q.desc ? '<p class="vq-qd">' + esc(q.desc) + '</p>' : '') +
      '<div class="vq-choices">';
    q.answers.forEach(function (a, i) {
      var sel = picked[step] === a ? ' vq-sel' : '';
      h += '<div class="vq-choice' + sel + '" data-act="pick" data-i="' + i + '">' +
        '<div class="vq-ctitle">' + esc(a.title) + '</div>' +
        (a.desc ? '<div class="vq-cdesc">' + esc(a.desc) + '</div>' : '') +
        '</div>';
    });
    h += '</div><div class="vq-nav">' +
      '<button class="vq-prev" data-act="prev">&#8592; &nbsp;Previous</button>' +
      (last ? '<button class="vq-btn" data-act="submit">Submit</button>' : '<span></span>') +
      '</div></div>';
    body.innerHTML = h;
  }

  function renderResult() {
    var exact = matches();
    var list = rank(exact, picked);
    var isFallback = false;
    if (!exact.length) {
      list = closest();
      isFallback = list.length > 0;
    }
    submitted = true;
    var pth = pathStr();
    track('quiz_submit', {
      phase: keyOf(0, QUIZ.questions[0].answers.indexOf(picked[0])),
      motor_type: keyOf(1, QUIZ.questions[1].answers.indexOf(picked[1])),
      requirement: keyOf(2, QUIZ.questions[2].answers.indexOf(picked[2])),
      panel_or_device: keyOf(3, QUIZ.questions[3].answers.indexOf(picked[3])),
      quiz_path: pth,
      result_count: exact.length,
      result_products: exact.map(function (p) { return p.handle; }).join(',')
    });
    if (!exact.length) track('quiz_no_match', { quiz_path: pth, fallback_count: list.length });

    if (inlineMode) { renderPanelResults(list, isFallback); return; }
    var h = '<div class="vq-wrap"><h2 class="vq-rhead">' + esc(QUIZ.resultHeading) + '</h2>';
    if (isFallback) {
      h += '<p class="vq-note" style="background:#FFF4E5;border:1px solid #F0C36D;color:#7A4E00;' +
        'padding:12px 14px;border-radius:6px;margin:0 0 18px;font-weight:600;line-height:1.55;">' +
        esc(QUIZ.noMatchText || '') + '</p>';
    }
    if (!list.length) {
      h += '<p class="vq-none">' + esc(QUIZ.noMatchText || 'No matching product found.') + '</p>';
    } else {
      h += '<div class="vq-grid">';
      list.forEach(function (p) {
        h += '<a class="vq-card" data-handle="' + p.handle + '" href="/products/' + p.handle + '">' +
          (p.image ? '<img src="' + p.image + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
          '<div class="vq-ptitle">' + esc(p.title) + '</div>' +
          '<div class="vq-price">' + money(p.price) +
          (p.compare > p.price ? '<span class="vq-was">' + money(p.compare) + '</span>' : '') +
          '</div></a>';
      });
      h += '</div>';
    }
    h += '<button class="vq-retake" data-act="retake">&#8635; &nbsp;' + esc(QUIZ.retakeLabel || 'Retake Quiz') + '</button></div>';
    body.innerHTML = h;
  }

  function openQuiz() {
    if (inlineMode) { inlineNeedsFocus = true; focusInline(); return; }
    load().then(function () {
      step = -1; picked = []; submitted = false;
      render();
      overlay.classList.add('vq-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      track('quiz_open', {});
    });
  }
  function closeQuiz() {
    if (inlineMode) return;
    if (!submitted && step >= 0) track('quiz_abandon', { last_step: step + 1, quiz_path: pathStr() });
    overlay.classList.remove('vq-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  window.VQ = { open: openQuiz, close: closeQuiz, match: matches, closest: closest, rank: rank,
    set: function (i, j) { picked[i] = QUIZ.questions[i].answers[j]; },
    reset: function () { picked = []; }, load: load };

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || t.nodeType !== 1) return;
    if (t.closest('a[href*="ttquiz"], [data-vq-open]')) { e.preventDefault(); openQuiz(); return; }
    if (t.closest('.vq-close')) { closeQuiz(); return; }
    if (t === overlay) { closeQuiz(); return; }

    if (inlineMode) {
      var productLink = t.closest('[data-vq-panel-product]');
      if (productLink && overlay.contains(productLink)) track('quiz_product_click', { item_handle: productLink.getAttribute('data-vq-panel-product'), quiz_path: pathStr() });
      var panelAction = t.closest('[data-act]');
      if (panelAction && overlay.contains(panelAction)) handlePanelAction(panelAction);
      return;
    }
    var card = t.closest('.vq-card');
    if (card && overlay.contains(card)) {
      track('quiz_product_click', { item_handle: card.getAttribute('data-handle'), quiz_path: pathStr() });
      return;
    }

    var el = t.closest('[data-act]');
    if (!el || !overlay.contains(el)) return;
    var act = el.getAttribute('data-act');
    if (act === 'start') { step = 0; render(); track('quiz_start', {}); }
    else if (act === 'prev') { step = Math.max(-1, step - 1); render(); }
    else if (act === 'retake') { step = -1; picked = []; submitted = false; render(); track('quiz_retake', {}); }
    else if (act === 'submit') { if (picked[step]) { step++; render(); } }
    else if (act === 'pick') {
      var ai = +el.getAttribute('data-i');
      picked[step] = QUIZ.questions[step].answers[ai];
      track('quiz_answer', { step: step + 1, question: slug(QUIZ.questions[step].title).slice(0, 40), answer: keyOf(step, ai) });
      if (step === QUIZ.questions.length - 1) { render(); }
      else { step++; render(); }
    }
  });

  if (inlineMode) {
    new MutationObserver(function () {
      var seen = {};
      body.querySelectorAll('.vq-wsub li').forEach(function (li) {
        var text = li.textContent.trim(); li.hidden = !!seen[text]; seen[text] = true;
      });
    }).observe(body, { childList: true, subtree: true, characterData: true });
    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches('[data-vq-panel-answer]') || !overlay.contains(input)) return;
      var answer = Number(input.value);
      picked[step] = QUIZ.questions[step].answers[answer];
      if (!panelStarted) { panelStarted = true; track('quiz_start', {}); }
      track('quiz_answer', { step: step + 1, question: slug(QUIZ.questions[step].title).slice(0, 40), answer: keyOf(step, answer) });
      body.querySelector('[data-act="panel-next"]').disabled = false;
    });
    step = 0; render();
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('vq-open')) closeQuiz();
  });
})();
